import React,{useEffect, useState} from 'react'
import { useSelector } from 'react-redux'
import Notification from '../../../shared/components/notification/notification'
import axios from 'axios'
import Cookies, { set } from 'js-cookie'
import { toast } from "react-toastify";


const Notifications = ({socket}) => {
    const user = useSelector((state) => state.userDetails.user);
    const [notification_state,setnotification_state]=useState([])
    const [toastduplicate,settoastduplicate]=useState(0)
useEffect(async()=>{
    

    const url = process.env.REACT_APP_SERVER_URL;
    const endpoint = `${url}/v1/notifications/get-notifications`
    const response = await axios({  headers: {'Content-Type': 'application/json','Authorization': Cookies.get('token')}, method: 'get',  timeout: 1000 * 60 * 10, url: endpoint, });
      if(response.data.success)
      {
        setnotification_state([...response.data.data])
      }
      else
      {
          toast.error(response.data.message)
      }

},[])


useEffect(()=>{

if(user && user.role[0] == "admin" && notification_state)
{
    socket.off('send_notification').on('send_notification', function (data) {
        // alert(JSON.stringify(data))
   
    var today = new Date();
    var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
    var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
    var dateTime = date+' '+time;
        const new_notification={name:data.name,email:data.email,message:data.message,createdAt:dateTime}
        
        let notify_array=[...notification_state];
        notify_array.unshift(new_notification)
        setnotification_state(notify_array)
        toast.success(`${data.name}, ${data.message}`)
        });
}

},[socket,notification_state])




    return (
        <div className="notificationCol bg-white border-radius-4 pb-0">
            <h6 className="px-3 pt-3 pb-3 mb-0">Notifications</h6>
            <div className="notification-holder">
                {notification_state && notification_state.map((notify)=>{
            
            return(<div className="media mb-2">
                    <Notification name={notify.name+""} message={notify.message} time={notify.createdAt} notify={notify} min="26" color="#AD0000" />
                    </div>
            )
                })}
            
                {/* <div className="media mb-2 active">
                    <Notification name="Mitchell" min="26" color="#00AD83" />
                </div> */}
            </div>
           
        </div>
    )
}

export default Notifications
